import type { ReactNode } from 'react';

import { memoGeneric } from '@/js/libs/memo/index.ts';

import { Loader } from '../../Elements/Loader/index.tsx';
import { NavigationItem } from './NavigationItem.tsx';
import { TabItem } from './TabItem.tsx';
import type { TabsGroupProps } from './types.ts';

export const TabsGroupContent = memoGeneric(function TabsGroupContent<TItem extends string = string>({
  items,
  navigationItems,
  activeId,
  onChange,
  isLoading,
}: TabsGroupProps<TItem>): ReactNode {
  if (isLoading) {
    return <Loader height={52} />;
  }

  if (navigationItems) {
    return navigationItems.map((item) => <NavigationItem key={item.to} {...item} />);
  }

  return items.map((item) => <TabItem<TItem> key={item.id} item={item} active={item.id === activeId} onTabChange={onChange} />);
});
